var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import chartUtils from '../utils/chart-utils';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';
import configureSolidGaugeYAxis from './solidGaugeYAxis';
import configureGaugeSeriesYAxis from './gaugeSeriesYAxis';
import parseAndSortData from '../utils/sortData';
import normalizeSeries from '../utils/normalizeSeries';
import constants from './constants';

var YAXIS_BASE = {
    lineWidth: 1,
    title: {
        style: {
            fontSize: '12px'
        }
    },
    labels: {
        style: {
            fontWeight: 700
        }
    },
    useHTML: true,
    reversedStacks: false
};

var XRANGE_YAXIS = {
    categories: []
};
var RADIALBAR_YAXIS = {
    lineWidth: 0,
    reversedStacks: false,
    endOnTick: true,
    showLastLabel: true,
    useHTML: true
};

var configureYAxis = function configureYAxis(widgetConfig, customConfig, seriesDataObj, seriesConfig) {
    var ChartConfig = widgetConfig.ChartConfig,
        BubbleChartConfig = widgetConfig.BubbleChartConfig,
        HistogramConfig = widgetConfig.HistogramConfig,
        GaugeConfig = widgetConfig.GaugeConfig,
        FlowConfig = widgetConfig.FlowConfig,
        HeatmapConfig = widgetConfig.HeatmapConfig,
        TreemapConfig = widgetConfig.TreemapConfig,
        XRangeConfig = widgetConfig.XRangeConfig;

    var config = cloneDeep(YAXIS_BASE);

    if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.RADIALBAR) return RADIALBAR_YAXIS;

    if (GaugeConfig) if (GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) return configureSolidGaugeYAxis(widgetConfig, seriesDataObj);else return configureGaugeSeriesYAxis(widgetConfig, seriesDataObj);

    if (HeatmapConfig) {
        var heatmapCategories = uniq(seriesDataObj.map(function (r) {
            return r[HeatmapConfig.ColumnField];
        }));
        return { categories: heatmapCategories, title: null };
    }
    if (XRangeConfig) {
        XRANGE_YAXIS.categories = seriesDataObj.categories;
        return XRANGE_YAXIS;
    }

    if (BubbleChartConfig || FlowConfig || TreemapConfig) return config;

    if (widgetConfig.Type.toLowerCase() === constants.chartTypes.BULLET) {
        var series = normalizeSeries(widgetConfig, seriesDataObj);
        var seriesData = parseAndSortData(series, widgetConfig, seriesDataObj);
        var targetValue = void 0,
            data = void 0,
            thresholdValue1 = void 0,
            thresholdValue2 = void 0,
            color1 = void 0,
            color2 = void 0,
            color3 = void 0;
        if (widgetConfig.BulletConfig.Series.length === 1) {
            targetValue = widgetConfig.BulletConfig.Series[0]['TargetValue'];
            data = seriesData[0][targetValue];
            thresholdValue1 = data * widgetConfig.BulletConfig.Series[0]['ThresholdValue1'] / 100;
            thresholdValue2 = data * widgetConfig.BulletConfig.Series[0]['ThresholdValue2'] / 100;
            color1 = widgetConfig.BulletConfig.Series[0]['FirstColor'];
            color2 = widgetConfig.BulletConfig.Series[0]['SecondColor'];
            color3 = widgetConfig.BulletConfig.Series[0]['ThirdColor'];
        } else {
            targetValue = seriesConfig['TargetValue'];
            data = seriesData[0][targetValue];
            thresholdValue1 = data * seriesConfig['ThresholdValue1'] / 100;
            thresholdValue2 = data * seriesConfig['ThresholdValue2'] / 100;
            color1 = seriesConfig['FirstColor'];
            color2 = seriesConfig['SecondColor'];
            color3 = seriesConfig['ThirdColor'];
        }
        return {
            plotBands: [{
                from: 0,
                to: thresholdValue1,
                color: color1
            }, {
                from: thresholdValue1,
                to: thresholdValue2,
                color: color2
            }, {
                from: thresholdValue2,
                to: 9e9,
                color: color3
            }],
            labels: {
                formatter: function formatter() {
                    return chartUtils.format(this.value, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat);
                }
            },
            title: null,
            gridLineWidth: 0
        };
    } else if (ChartConfig && ChartConfig.ChartType.toLowerCase() == constants.chartTypes.PYRAMID) return {};

    if (HistogramConfig) {
        config.title.text = HistogramConfig.YAxisName;
        return config;
    }

    var ChartType = ChartConfig.ChartType,
        GridLines = ChartConfig.GridLines,
        HideYAxis = ChartConfig.HideYAxis,
        SecondaryAxisLabel = ChartConfig.SecondaryAxisLabel;

    if (ChartType.toLowerCase() == 'pie' || ChartType.toLowerCase() == 'doughnut') return config;else if (ChartType.toLowerCase() == 'funnel') return {};
    var Series = ChartConfig.Series,
        DefaultRange = ChartConfig.DefaultRange;

    var axes = [];

    //copy the series array because sort is called in place
    var sortedSeries = [].concat(Series);
    sortedSeries.sort(function (a, b) {
        if (a.PlotSecondaryAxis && !b.PlotSecondaryAxis) return 1;else if (!a.PlotSecondaryAxis && b.PlotSecondaryAxis) return -1;else return 0;
    });

    sortedSeries.forEach(function (seriesConfig) {
        var SeriesName = seriesConfig.SeriesName,
            PlotSecondaryAxis = seriesConfig.PlotSecondaryAxis,
            SecondaryAxisCurrencySymbol = seriesConfig.SecondaryAxisCurrencySymbol,
            AggregationType = seriesConfig.AggregationType,
            FieldName = seriesConfig.FieldName;


        if (axes.length === 0 || axes.length === 1 && PlotSecondaryAxis) {
            var baseFormat = void 0,
                valueFormat = void 0;
            if (PlotSecondaryAxis) {
                valueFormat = seriesConfig.SecondaryAxisValueFormat || ChartConfig.ValueFormat;
                baseFormat = seriesConfig.SecondaryAxisBaseFormat || ChartConfig.BaseFormat;
            } else {
                valueFormat = ChartConfig.ValueFormat;
                baseFormat = ChartConfig.BaseFormat;
            }

            axes.push({
                field: FieldName,
                currency: PlotSecondaryAxis ? SecondaryAxisCurrencySymbol : ChartConfig.CurrencySymbol,
                seriesName: SeriesName,
                aggregationType: AggregationType,
                baseFormat: baseFormat,
                valueFormat: valueFormat,
                defaultRange: DefaultRange
            });
        }
    });

    config = axes.reduce(function (acc, axisConfig, i) {
        var ShowTotalLabels = ChartConfig.Series[i].ShowTotalLabels;

        var opposite = void 0,
            min = void 0,
            max = void 0;
        opposite = i > 0;
        var title = void 0;
        if (i === 0 && ChartConfig.ValueName) {
            title = ChartConfig.ValueName;
        } else if (i === 1 && SecondaryAxisLabel) {
            title = SecondaryAxisLabel;
        } else if (i > 0) {
            var prefix = void 0;
            axisConfig.aggregationType === 'COUNT' ? prefix = '#' : prefix = '';
            title = prefix + ' ' + axisConfig.seriesName;
        }

        //to fix 0 values to bottom in the event that all values are 0
        var singleValueConfig = {};
        if (axisConfig.range && axisConfig.range.sum === 0) {
            singleValueConfig = {
                minPadding: 0,
                maxPadding: 0,
                min: 0,
                max: 1,
                showLastLabel: false,
                tickInterval: 1
            };
        }

        acc.push(_extends({
            lineWidth: 1,
            title: {
                text: title,
                style: {
                    fontSize: '12px'
                }
            },
            tickAmount: [ChartConfig.TickCount] == 0 ? null : [ChartConfig.TickCount],
            opposite: opposite,
            softMin: axisConfig.defaultRange ? 0 : null,
            visible: i === 0 || i === axes.length - 1,
            gridLineWidth: ['Both', 'YAxis'].includes(GridLines) ? 1 : 0,
            labels: {
                enabled: !HideYAxis,
                formatter: function formatter() {
                    var valueFormat = axisConfig.valueFormat,
                        baseFormat = axisConfig.baseFormat,
                        currency = axisConfig.currency;

                    var label = void 0;

                    if (valueFormat == '%') valueFormat = '.0%';
                    label = chartUtils.format(this.value, valueFormat, currency, null, baseFormat);

                    return label;
                },
                style: {
                    fontWeight: 700
                }
            },
            stackLabels: {
                enabled: ShowTotalLabels,
                formatter: function formatter() {
                    var valueFormat = axisConfig.valueFormat,
                        baseFormat = axisConfig.baseFormat,
                        currency = axisConfig.currency;

                    var label = void 0;
                    if (valueFormat == '%') valueFormat = '.0%';
                    label = chartUtils.format(this.total, valueFormat, currency, null, baseFormat);

                    return label;
                },
                style: {
                    fontWeight: 'normal'
                }
            },
            useHTML: true,
            reversedStacks: false
        }, singleValueConfig, cloneDeep(customConfig)));
        return acc;
    }, []);

    return config;
};

export default configureYAxis;